/**
 * Resolución del API según el dominio desde el que se sirve la aplicación.
 *
 * La regla es:
 *
 *   - Cualquier acceso por dirección IP  -> api.reprico.dev
 *   - Cualquier dominio terminado en .dev -> api.reprico.dev
 *   - Cualquier otro dominio              -> api.reprico.net
 *
 * El motivo de mandar las IP a desarrollo es que a producción se entra por su
 * dominio, nunca por IP. Antes solo `localhost` y `127.0.0.1` iban a
 * desarrollo, así que abrir la aplicación por la IP del servidor —por ejemplo
 * el puerto que publica docker-compose— hacía que una imagen de staging
 * hablara con el API de producción sin ninguna señal visible.
 */

const API_DESARROLLO = 'https://api.reprico.dev';
//const API_DESARROLLO = 'https://api.reprico.net';
const API_PRODUCCION = 'https://api.reprico.net';

/** IPv4 en notación decimal: 10.41.0.6, 192.168.1.50, 127.0.0.1. */
const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/;

function getBrowserHostname(): string {
    if (typeof window === 'undefined') {
        return '';
    }

    return window.location.hostname.toLowerCase().trim();
}

/**
 * `true` si el host es una dirección IP y no un nombre.
 *
 * El navegador entrega las IPv6 entre corchetes (`[::1]`), y siempre llevan
 * dos puntos, que en un nombre de dominio no pueden aparecer.
 */
function esDireccionIp(hostname: string): boolean {
    return IPV4.test(hostname) || hostname.includes(':') || hostname.startsWith('[');
}

/** `true` para localhost y sus variantes, incluidos los subdominios .localhost. */
function esLocal(hostname: string): boolean {
    return hostname === 'localhost' || hostname.endsWith('.localhost') || hostname === 'localhost.localdomain';
}

export function resolveApiOrigin(): string {
    return resolveApiOriginForHostname(getBrowserHostname());
}

/**
 * La misma regla para un host dado. La usa también el servidor Node (src/server/), que
 * valida tokens contra el Identity del mismo ambiente que atiende la petición.
 */
export function resolveApiOriginForHostname(rawHostname: string): string {
    const hostname = rawHostname.toLowerCase().trim();

    // Sin host (compilación o pruebas): se asume desarrollo.
    if (!hostname) {
        return API_DESARROLLO;
    }

    if (esDireccionIp(hostname) || esLocal(hostname)) {
        return API_DESARROLLO;
    }

    if (hostname.endsWith('.dev')) {
        return API_DESARROLLO;
    }

    return API_PRODUCCION;
}